import React from "react";
import { Container, Row, Col, Image, Card, Button } from "react-bootstrap";
import fishMain from "../Assets/Image/fish1.jpg";
import fish1 from "../Assets/Image/fish-1.jpg";
import fish2 from "../Assets/Image/fish-2.jpg";
import fish3 from "../Assets/Image/fish-3.jpg";
import fish4 from "../Assets/Image/fish-4.jpg";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Helmet } from "react-helmet";

const FishPlatesforBusbartrunking = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Fish Plates for Busbar Trunking | Delta Engineering</title>
        <meta
          name="description"
          content="High-performance fish plates for busbar trunking systems. Ensures reliable jointing, electrical conductivity, and structural integrity in LV & MV power distribution applications."
        />
        <meta
          name="keywords"
          content="Fish Plates for Busbar Trunking, Busbar Jointing Plates, Copper Fish Plate, Aluminum Fish Plate, Electrical Busbar Connectors, Busbar Coupler Plate, Busbar Accessories, Switchgear Fish Plate"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Fish Plates for Busbar Trunking" />
        <meta
          property="og:description"
          content="Durable and precision-engineered fish plates for LV & MV busbar trunking systems. Available in copper and aluminum with plating options for corrosion resistance."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.yourdomain.com/fish-plates-for-busbar-trunking"
        />
        <meta
          property="og:image"
          content="https://www.yourdomain.com/images/fish-plates-busbar-trunking.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Fish Plates for Busbar Trunking | Delta Engineering"
        />
        <meta
          name="twitter:description"
          content="Engineered fish plates for reliable electrical and mechanical integrity in busbar trunking systems. Customizable in copper or aluminum."
        />
        <meta
          name="twitter:image"
          content="https://www.yourdomain.com/images/fish-plates-busbar-trunking.jpg"
        />
      </Helmet>

      <section className="productbanner1 d-flex align-items-center position-relative">
        <div className="overlay-layer"></div>
        <Container className="text-center position-relative z-2">
          <Row className="justify-content-center">
            <Col lg={8} className="hero-content text-center">
              <h2
                className="hero-title"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
                <span className="blue-text">Fish Plates for </span>{" "}
                <span className="white-text">Busbar Trunking</span>
              </h2>
              <p
                className="hero-subtitle"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                Engineered for durability, fish plates ensure reliable joints
                and seamless conductivity in busbar trunking systems.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <div
        className="fishplate-section py-3 bg-light"
        style={{ position: "relative" }}
      >
        <Button onClick={() => navigate("/ourproducts")} className="back-btn">
          <IoMdArrowRoundBack className="back-icon" />
          Back
        </Button>
        <Container>
          <Row className="text-center mb-4">
            <Col>
              <h3 className="fw-bold section-title">
                Fish Plates for Busbar Trunking{" "}
                <span className="title-underline"></span>
              </h3>
              <p className="text-muted mb-4">
                High-performance fish plates offering rigid support and seamless
                connection between adjacent busbars.
              </p>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col md={4}>
              <Image
                src={fishMain}
                fluid
                rounded
                alt="Fish Plate for Busbar Trunking"
                height={500}
                width={400}
              />
            </Col>
            <Col md={8}>
              <h5 className="fw-semibold">Key Features:</h5>
              <ul className="text-muted ps-3">
                <li>
                  Maintains electrical and mechanical integrity between busbar
                  joints
                </li>
                <li>Available in copper and aluminum</li>
                <li>Custom hole patterns and insulation available</li>
                <li>
                  Precision machined for tight fit and corrosion resistance
                </li>
                <li>Compatible with a wide range of busbar trunking systems</li>
              </ul>

              <h5 className="fw-semibold mt-4">Surface Treatment Options:</h5>
              <ul className="text-muted ps-3">
                <li>Natural finish</li>
                <li>Tin Plated</li>
                <li>Nickel or Silver plated (on request)</li>
              </ul>
            </Col>
          </Row>
          <h5 className="fw-semibold">Applications:</h5>
          <ul className="text-muted ps-3">
            <li>LV & MV Busbar Trunking Systems</li>
            <li>Switchgear assemblies</li>
            <li>Power transmission and distribution systems</li>
            <li>Industrial automation panels</li>
          </ul>

          <h5 className="fw-semibold mt-4">Specifications:</h5>
          <ul className="text-muted ps-3">
            <li>Material: Copper / Aluminum</li>
            <li>Thickness: 3mm to 10mm</li>
            <li>Length: Customizable</li>
            <li>Finish: Bare / Tinned / Plated</li>
            <li>Mounting holes and fasteners as per drawing</li>
          </ul>

          <h5 className="fw-semibold mt-4">Customization:</h5>
          <p className="text-muted">
            We offer fish plates as per client drawings, dimensions, and finish
            requirements. Each unit undergoes quality and fitment checks before
            dispatch.
          </p>
        </Container>
      </div>
    </>
  );
};

export default FishPlatesforBusbartrunking;
